import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {map, Observable, tap} from "rxjs";
import {environment} from "../../environments/environment";
import {BaseResponse} from "../entities/base-response";
import {ApplicantProject} from "../entities/projects.entities";
import {TokenRequestModel} from "../entities/token-request";
import {RequestAnalytics} from "../entities/request-analytics";
import {CacheService} from "../services/cache.service";
import {TWELVE} from "../commons/constans";

@Injectable({
  providedIn: 'root'
})
export class AmadWebNetworkService {

  private readonly BASE_URL = environment.baseUrl; // Cambia esto por tu URL base

  constructor(
    private http: HttpClient,
    private cacheService:CacheService,
  ) {}

  load(tokenRequest: TokenRequestModel): Observable<BaseResponse<string>> {
    const url = `${this.BASE_URL}load`;
    return this.http.post<BaseResponse<string>>(url,tokenRequest).pipe(
      tap(value => this.cacheService.set(CacheService.TOKEN,value.token,TWELVE))
    );
  }

  sendClicks(clickData: RequestAnalytics): Observable<BaseResponse<string>> {
    const url = `${this.BASE_URL}click`;
    const headers = new HttpHeaders({ 'token': this.cacheService.get(CacheService.TOKEN) ??"" });
    return this.http.post<BaseResponse<string>>(url, clickData,{headers:headers});
  }

  getConfig(id: string): Observable<ApplicantProject> {
    const url = `${this.BASE_URL}layout/${id}`;
    const headers = new HttpHeaders({ 'token': this.cacheService.get(CacheService.TOKEN) ??"" });

    return this.http.get<BaseResponse<ApplicantProject>>(url,{headers:headers})
      .pipe(map(data => data.data));
  }
}
